import React from 'react'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="d-sm-flex justify-content-center">
        <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">
          Copyright © {new Date().getFullYear()} Harmony Jewels
        </span>
        {/* <span className="text-muted d-block text-center text-sm-left d-sm-inline-block"> Developed by <a
                    href="http://www.grapestechsolutions.com/" target="_blank">GrapesTech Solutions Pvt. Ltd.</a></span> */}
      </div>
    </footer>
  )
}

export default Footer
